// extracted by mini-css-extract-plugin
export default {"container":"Gn-z","bubbleNav":"Hn-z","graphic":"In-z","contact":"Jn-z"};